export class KeyValue<T> {
  key: string;
  value: T;
}
